<template>
  <Teleport to="#dialog-container">
    <transition name="fade">
      <div v-if="active" class="w-screen h-full absolute z-80000 left-0 bottom-0 flex flex-col items-end justify-end pointer-events-none">
        <div class="mx-auto m-6 w-full max-w-sm z-20 pointer-events-auto">
          <div
            class="px-3 py-4 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl shadow-lg mx-3 md:-mx-5 flex items-center justify-between"
          >
            <div class="flex items-center mx-2">
              <template v-if="loading">
                <o-loader
                  :scale="0.3"
                  class="h-8 w-8 mx-auto mr-3"
                />
                <p class="text-gray-700 dark:text-gray-200 text-sm font-medium leading-none mt-px">
                  {{ $t('general.loadingEllipses') }}
                </p>
              </template>
              <template v-else>
                <o-icon :size="18" icon="warning" class="mr-3 text-amber-600 dark:text-amber-400" />
                <p class="text-gray-700 dark:text-gray-200 text-sm font-medium leading-none mt-px">
                  {{ message }}
                </p>
              </template>
            </div>
            <div class="flex items-center space-x-1">
              <slot>
                <UButton variant="subtle" color="primary" class="mr-2" @click="$emit('cancel')">
                  {{ $t('general.cancel') }}
                </UButton>

                <UButton icon="lucide:save" variant="solid" color="primary" class="mr-2" @click="$emit('save')">
                  {{ $t('components.elements.actionBar.save') }}
                </UButton>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<script lang="ts">
export default { name: 'OActionBar' }
</script>

<script setup lang="ts">
const { $i18n } = useNuxtApp()

interface Props {
  active?: boolean
  loading?: boolean
  message?: string
}

const props = withDefaults(defineProps<Props>(), {
  active: false,
  loading: false,
  message: undefined,
})

// The original used this.$t() in the prop default, which isn't available in setup.
// We shadow the prop with a computed to provide the i18n default.
const message = computed(() => props.message ?? $i18n.t('components.elements.actionBar.unsavedChanges') as string)

defineEmits<{
  (e: 'cancel'): void
  (e: 'save'): void
}>()
</script>
